import { useProgramContextWithGuidesAndWorkflow } from '@rhg/hooks/use-program-context/with-guides-and-workflow';
import { useProvidedProgramContext } from '..';

export function useProvidedProgramContextWithGuidesAndWorkflow() {
    const {
        program,
        programMetadata,
        packProgram,
        packClass,
        recommendation,
        contentFeedbackId,
        isFetched,
        _workflow,
    } = useProvidedProgramContext();
    return useProgramContextWithGuidesAndWorkflow({
        program,
        programMetadata,
        packProgram,
        packClass,
        recommendation,
        contentFeedbackId,
        isFetched,
        workflow: _workflow,
    });
}
